import React from 'react';
import { useActor } from '@xstate/react';
import SubmitCaseViewProps from './types/SubmitCaseViewProps';
import { useSubmitCaseContext } from '../../context/SubmitCaseContext';
import CaseCheckout from '../case/CaseCheckout';
import { PaymentType } from '../../stateMachines/submitCase/selectPaymentType';
import FullscreenLoader from '../common/FullscreenLoader';

interface CheckoutProps extends SubmitCaseViewProps {}

const Checkout: React.FC<CheckoutProps> = ({ ...props }) => {
  const { submitCaseService } = useSubmitCaseContext();
  const [state, send] = useActor(submitCaseService);

  const { caseInfo, uploadProgress } = state.context;

  const isLoading = state.matches({ checkout: 'load' }) ||
                    state.matches({ checkout: 'ensureSetupIntent' }) ||
                    state.matches({ checkout: 'confirmingSetupIntent' });
  const isSubmitting = state.matches({ checkout: 'submitCase' });

  if (!caseInfo) {
    return null;
  }

  if (isLoading || !state.context.lineItems || state.context.totalPrice === undefined) {
    return <FullscreenLoader show={true} />;
  }

  return (
    <CaseCheckout
      caseUserId={state.context.userId}
      clinicName={state.context.name}
      clinicEmail={state.context.email}
      invoicingEnabled={state.context.paymentType === PaymentType.INVOICE}
      parentAccount={state.context.parentAccount}
      onSubmit={() => send('NEXT')}
      onBack={() => send('BACK')}
      caseInfo={caseInfo}
      isSubmitting={isSubmitting}
      progress={uploadProgress}
      selectedInvoiceAccountUid={state.context.selectedInvoiceAccountUid}
      lineItems={state.context.lineItems || []}
      total={state.context.totalPrice || 0}
      priorityUpgradePrice={state.context.priorityUpgradePrice || 0}
      error={state.context.error}
    />
  );
};

export default Checkout;
